<template>
  <app-layout>
    <template slot="subSectionMenu">
      <v-list-tile
        v-if="$router.currentRoute.path != '/myconsultant'"
        @click="goToMyConsultant"
        value="true"
      >
        <v-list-tile-action class="pr-0">
          <v-icon v-html="'mdi-comment-text-multiple-outline'"></v-icon>
        </v-list-tile-action>
        <v-list-tile-content>
          <v-list-tile-title class="caption font-weight-medium">
            {{ $t('Mis conversaciones') }}
          </v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>

      <!-- <og-upload-document>
                <v-list-tile to="/openbox/upload" slot="documentActivator">
                    <v-list-tile-action class="pr-0">
                        <v-icon v-html="'mdi-calculator'"></v-icon>
                    </v-list-tile-action>
                    <v-list-tile-content>
                        <v-list-tile-title class="caption font-weight-medium"> {{$t('A contabilizar')}} </v-list-tile-title>
                    </v-list-tile-content>
                </v-list-tile>
            </og-upload-document> -->
      <v-tooltip right>
        <template v-slot:activator="{ on, attrs }">
          <v-list-tile @click="threadForm = true" v-bind="attrs" v-on="on">
            <v-list-tile-action class="pr-0">
              <v-icon v-html="'mdi-comment-text-outline'"></v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title class="caption font-weight-medium">
                {{ $t('Nueva conversación') }}
              </v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
        </template>
        <span>{{ $t('Nueva conversación') }}</span>
      </v-tooltip>

      <v-dialog v-model="threadForm" persistent max-width="964px">
        <thread-form
          :new-data="newThreadData"
          @created="addThread"
          @closeForm="threadForm = false"
        ></thread-form>
      </v-dialog>

      <!-- <v-list-tile @click="dateForm = true" >
                <v-list-tile-action class="pr-0">
                    <v-icon v-html="'mdi-calendar-range-outline'"></v-icon>
                </v-list-tile-action>
                    <v-list-tile-content>
                        <v-list-tile-title class="caption font-weight-medium"> {{$t('Pedir cita')}} </v-list-tile-title>
                    </v-list-tile-content>
            </v-list-tile> -->
      <!-- <v-dialog v-model="dateForm" persistent max-width="500px">
                <consultant-date-form  @closeDialog="dateForm = false"></consultant-date-form>


            </v-dialog> -->
      <!--  -->
    </template>
    <dashboard-layout>
      <template slot="header"></template>
      <template slot="header-out">
        <conversation-detail v-if="$route.name === 'threadDetail'"></conversation-detail>
        <conversation-list v-else></conversation-list>
      </template>
      <template slot="sidebar">
        <v-flex md12>
          <my-consultant-conversation></my-consultant-conversation>
        </v-flex>
        <v-flex md12 pt-3>
          <calendar-events></calendar-events>
        </v-flex>
      </template>
    </dashboard-layout>
  </app-layout>
</template>

<script>
import AppLayout from '@/views/layouts/AppLayout.vue';
import DashboardLayout from '@/views/layouts/DashboardLayout.vue';
import MyConsultantConversation from '../components/threads/MyConsultantConversation.vue';
import CalendarEvents from '@/modules/calendar/components/CalendarEvents.vue';
import ConversationDetail from '../components/threads/ConversationDetail.vue';
import ThreadForm from '../components/threads/ThreadForm';
// import DateMenuForm from '@/components/events/DateMenuForm';

import ConversationList from '../components/threads/ConversationList';

export default {
  components: {
    AppLayout,
    CalendarEvents,
    MyConsultantConversation,
    DashboardLayout,
    ConversationList,
    ConversationDetail,
    ThreadForm,
    // DateMenuForm,
  },

  data() {
    return {
      threadForm: false,
      newThreadData: {},
      dateForm: false,
    };
  },
  methods: {
    goToMyConsultant() {
      this.$router.push('/myconsultant');
    },
    addThread(data) {
      console.log(data);
      this.threadForm = false;
      this.$router.push('/myconsultant/thread/' + data.data.id);
      // console.log('Add thread');
    },
  },
};
</script>

<style lang="scss" scoped>
.v-list {
  &__tile {
    &__action {
      min-width: 35px;
    }
  }
}
</style>
